import {
  Component,
  DestroyRef,
  inject,
  input,
  signal
} from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AnimationOptions } from 'ngx-lottie';
import { LoaderService } from '../../../core/services/loader.service';
import { LottieAnimation } from '../lottie-animation/lottie-animation';

@Component({
  selector: 'isc-loader',
  imports: [LottieAnimation],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class Loader {

  // ✅ Inputs using signals
  icon = input<string>('lightbulb-loader');
  showMsg = input<boolean>(false);
  message = input<string>('Please wait...');

  // ✅ Reactive state
  isLoading = signal(false);
  progressPercent = signal<number | null>(null);

  private readonly loaderService = inject(LoaderService);
  private readonly destroyRef = inject(DestroyRef);

  // ✅ Lottie config
  lottieOptions: AnimationOptions = {
    path: `../../../../assets/lottie/${this.icon()}.json`,
    autoplay: true,
    loop: true,
  };
// /home/suchit/Work/codeCommit/insights_cube_ui/public/assets/lottie/lightbulb-loader.json
// public/assets/lottie/lightbulb-loader.json
  constructor() {

    this.loaderService.isLoading$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.isLoading.set(res);
      });

    this.loaderService.progressPercent$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.progressPercent.set(res);
      });
  }
}